import { Home, FileText, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const HomeBuyerPage = () => {
  const navigate = useNavigate();

  const services = [
    {
      id: 1,
      icon: Home,
      title: "Home Buyer RERA Advisory Services",
      description: "Get the right guidance and essential information to make informed property-buying decisions.",
      path: "/home-buyer/advisory-services"
    },
    {
      id: 2,
      icon: FileText,
      title: "Sale Agreement Review",
      description: "Understand important clauses, legal terms, and key details before signing your property sale agreement.",
      path: "/home-buyer/sale-agreement-review"
    }
  ];

  return (
    <div className="min-h-screen fade-in" data-testid="home-buyer-page">
      {/* Hero Section */}
      <section className="pt-32 pb-16 md:pb-20 section-light" data-testid="home-buyer-hero">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
          <div className="text-center max-w-3xl mx-auto">
            <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C9A14A] mb-4">
              Home Buyer
            </div>
            <h1
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-tight leading-tight text-[#1A1A1A] mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Home Buyer Services
            </h1>
            <p className="text-base sm:text-lg md:text-xl leading-relaxed text-[#555555]">
              Everything you need to know before buying your dream home.
            </p>
          </div>
        </div>
      </section>

      {/* Service Cards Section */}
      <section className="py-16 md:py-24 section-grey" data-testid="home-buyer-services">
        <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {services.map((service) => {
              const Icon = service.icon;
              return (
                <div
                  key={service.id}
                  onClick={() => navigate(service.path)}
                  className="group bg-white rounded-xl p-6 sm:p-8 md:p-10 shadow-sm border border-slate-100 cursor-pointer transition-all duration-300 hover:shadow-lg hover:border-[#C9A14A]/40 hover:-translate-y-1"
                  data-testid={`service-card-${service.id}`}
                >
                  {/* Icon */}
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#C9A14A]/10 flex items-center justify-center mb-6 group-hover:bg-[#C9A14A]/20 transition-colors duration-300">
                    <Icon className="w-7 h-7 md:w-8 md:h-8 text-[#C9A14A]" />
                  </div>

                  {/* Title */}
                  <h3
                    className="text-xl sm:text-2xl font-semibold text-[#1A1A1A] mb-3 group-hover:text-[#C9A14A] transition-colors duration-300"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    {service.title}
                  </h3>

                  {/* Description */}
                  <p className="text-sm sm:text-base text-[#555555] leading-relaxed mb-6">
                    {service.description}
                  </p>

                  {/* CTA */}
                  <div className="flex items-center gap-2 text-[#C9A14A] font-medium group-hover:gap-3 transition-all duration-300">
                    <span className="text-sm sm:text-base">Explore Services</span>
                    <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-20 section-light" data-testid="home-buyer-cta">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
          <div className="bg-white p-8 sm:p-10 md:p-14 rounded-xl shadow-sm border border-slate-100 text-center">
            <h2
              className="text-2xl sm:text-3xl md:text-4xl tracking-tight leading-snug text-[#1A1A1A] mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Need Expert Guidance?
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-[#555555] mb-8 max-w-2xl mx-auto">
              Our team of RERA experts is here to help you navigate the home buying process with confidence and clarity.
            </p>
            <button
              onClick={() => navigate("/contact")}
              className="btn-accent px-6 sm:px-8 py-3 sm:py-4 rounded-md font-medium text-sm sm:text-base"
            >
              Contact Us Today
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomeBuyerPage;
